// Library methods
import { useTranslation } from "react-i18next";

// MUI Components
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import DefaultModal from "../DefaultModal";

// Styles
import { ModalCustomCancel } from "../../../styles/muiStylesHelper";

const UnavailableDeviceModal = ({ open, onClose, onCancel }) => {
  // internationalization
  const { t } = useTranslation();

  return (
    <DefaultModal
      isOpen={open}
      onClose={onClose}
      title={t("device_unavailable_modal_title")}
      maxWidth="xs"
      modalActions={
        <Grid
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "20px",
          }}
        >
          <Button variant="text" sx={ModalCustomCancel} onClick={onCancel}>
            {t("button_close")}
          </Button>
        </Grid>
      }
    >
      <Grid display="flex" flexDirection="column" p="20px" gap="20px">
        <Typography id="modal-modal-description">
          {t("device_unavailable_description")}
        </Typography>
      </Grid>
    </DefaultModal>
  );
};

export default UnavailableDeviceModal;
